import { REDUX } from 'constants/'
import {
    NotificationReducerTypeInitiator,
    NotificationAction,
    NotificationReducer
} from 'types/notification'
/**
 * Reducer para objeto notification
 * @param state
 * @param action
 */
const NotificationsReducer = (
    state = NotificationReducerTypeInitiator,
    action: NotificationAction
): NotificationReducer => {
    switch (action.type) {
        case REDUX.reducers.ERROR_ALL_PLAN_ACTION:
            return {
                ...state,
                error: true,
                loading: false
            } as NotificationReducer
        case REDUX.reducers.LOADING_ALL_PLAN_ACTION:
            return {
                ...state,
                error: false,
                loading: true
            } as NotificationReducer
        case REDUX.reducers.GET_ALL_PLAN_ACTION:
            return {
                ...state,
                actionPlans: action.payload,
                error: false,
                loading: false
            } as NotificationReducer
        // Cases para Plano de Ação em Grupo
        case REDUX.reducers.ERROR_ALL_PLAN_ACTION_GROUP:
            return {
                ...state,
                errorGroup: true,
                loadingGroup: false
            } as NotificationReducer
        case REDUX.reducers.LOADING_ALL_PLAN_ACTION_GROUP:
            return {
                ...state,
                errorGroup: false,
                loadingGroup: true
            } as NotificationReducer
        case REDUX.reducers.GET_ALL_PLAN_ACTION_GROUP:
            return {
                ...state,
                actionPlansGroup: action.payload,
                errorGroup: false,
                loadingGroup: false
            } as NotificationReducer
        case REDUX.reducers.CLEAR_PLAN_ACTION_GROUP:
            return {
                ...state,
                actionPlansGroup: [],
                errorGroup: false,
                loadingGroup: false
            } as NotificationReducer
        // Batch Action Plan Cases
        case REDUX.reducers.CREATE_BATCH_PLAN_ACTION_LOADING:
            return {
                ...state,
                batchActionPlanLoading: true,
                batchActionPlanError: null,
                batchActionPlanResult: null
            } as NotificationReducer
        case REDUX.reducers.CREATE_BATCH_PLAN_ACTION_SUCCESS:
            return {
                ...state,
                batchActionPlanLoading: false,
                batchActionPlanError: null,
                batchActionPlanResult: action.payload
            } as NotificationReducer
        case REDUX.reducers.CREATE_BATCH_PLAN_ACTION_ERROR:
            return {
                ...state,
                batchActionPlanLoading: false,
                batchActionPlanError: action.payload,
                batchActionPlanResult: null
            } as NotificationReducer
        case REDUX.reducers.CLEAR_BATCH_PLAN_ACTION_RESULT:
            return {
                ...state,
                batchActionPlanLoading: false,
                batchActionPlanError: null,
                batchActionPlanResult: null
            } as NotificationReducer
        // Update Batch Action Plan Cases
        case REDUX.reducers.UPDATE_BATCH_PLAN_ACTION_LOADING:
            return {
                ...state,
                batchActionPlanLoading: true,
                batchActionPlanError: null,
                batchActionPlanResult: null
            } as NotificationReducer
        case REDUX.reducers.UPDATE_BATCH_PLAN_ACTION_SUCCESS:
            return {
                ...state,
                batchActionPlanLoading: false,
                batchActionPlanError: null,
                batchActionPlanResult: action.payload
            } as NotificationReducer
        case REDUX.reducers.UPDATE_BATCH_PLAN_ACTION_ERROR:
            return {
                ...state,
                batchActionPlanLoading: false,
                batchActionPlanError: action.payload,
                batchActionPlanResult: null
            } as NotificationReducer
        // Delete Batch Action Plan Cases
        case REDUX.reducers.DELETE_BATCH_PLAN_ACTION_LOADING:
            return {
                ...state,
                batchActionPlanLoading: true,
                batchActionPlanError: null,
                batchActionPlanResult: null
            } as NotificationReducer
        case REDUX.reducers.DELETE_BATCH_PLAN_ACTION_SUCCESS:
            return {
                ...state,
                batchActionPlanLoading: false,
                batchActionPlanError: null,
                batchActionPlanResult: action.payload
            } as NotificationReducer
        case REDUX.reducers.DELETE_BATCH_PLAN_ACTION_ERROR:
            return {
                ...state,
                batchActionPlanLoading: false,
                batchActionPlanError: action.payload,
                batchActionPlanResult: null
            } as NotificationReducer
        // Batch Ishikawa Cases
        case REDUX.reducers.CREATE_BATCH_ISHIKAWA_LOADING:
            return {
                ...state,
                batchIshikawaLoading: true,
                batchIshikawaError: null,
                batchIshikawaResult: null
            } as NotificationReducer
        case REDUX.reducers.CREATE_BATCH_ISHIKAWA_SUCCESS:
            return {
                ...state,
                batchIshikawaLoading: false,
                batchIshikawaError: null,
                batchIshikawaResult: action.payload
            } as NotificationReducer
        case REDUX.reducers.CREATE_BATCH_ISHIKAWA_ERROR:
            return {
                ...state,
                batchIshikawaLoading: false,
                batchIshikawaError: action.payload,
                batchIshikawaResult: null
            } as NotificationReducer
        case REDUX.reducers.UPDATE_BATCH_ISHIKAWA_LOADING:
            return {
                ...state,
                batchIshikawaLoading: true,
                batchIshikawaError: null,
                batchIshikawaResult: null
            } as NotificationReducer
        case REDUX.reducers.UPDATE_BATCH_ISHIKAWA_SUCCESS:
            return {
                ...state,
                batchIshikawaLoading: false,
                batchIshikawaError: null,
                batchIshikawaResult: action.payload
            } as NotificationReducer
        case REDUX.reducers.UPDATE_BATCH_ISHIKAWA_ERROR:
            return {
                ...state,
                batchIshikawaLoading: false,
                batchIshikawaError: action.payload,
                batchIshikawaResult: null
            } as NotificationReducer
        case REDUX.reducers.GET_CURRENT_NOTIFICATION: //! Duplicated
            return {
                ...state,
                notificationById: action.payload,
                error: false,
                loading: false
            } as NotificationReducer
        case REDUX.reducers.RENDER_NOTIFICATION_SCREEN:
            return {
                ...state,
                notificationScreen: action.payload,
                notificationById: null,
                notificationSelected: null,
                error: true,
                loading: false
            } as NotificationReducer
        case REDUX.reducers.GET_ALL_NOTIFICATIONS:
        return {
                ...state,
                notificationsList: action.payload,
                notificationById: null,
                notificationSelected: null,
                error: false,
                loading: false
            } as NotificationReducer
        case REDUX.reducers.SELECT_NOTIFICATION:
            return {
                ...state,
                notificationSelected: action.payload,
                error: false,
                loading: true
            } as NotificationReducer
        // case REDUX.reducers.GET_CURRENT_NOTIFICATION://! Duplicated, never reaches this condition
        //     return {
        //         ...state,
        //         notificationSelected: action.payload,
        //         error: false,
        //         loading: true
        //     } as NotificationReducer 
        case REDUX.reducers.LOAD_NOTIFICATIONS_STAT:
            return {
                ...state,
                notificationsList: [],
                error: false,
                loadingStats: true
            } as NotificationReducer
        case REDUX.reducers.LOAD_NOTIFICATIONS:
            return {
                ...state,
                notificationsList: [],
                error: false,
                loading: true
            } as NotificationReducer
        case REDUX.reducers.GET_ALL_NOTICATIONS_PER_MONTH:
            return {
                ...state,
                notificationsPerMonthCount: action.payload,
                error: false,
                loading: false
            }
        case REDUX.reducers.GET_MOST_RECLASSIFIED_INCIDENT_TYPE:
            return {
                ...state,
                mostReclassifiedIncidentType: action.payload,
                error: false,
                loading: false
            }
        case REDUX.reducers.GET_ALL_NOTICATIONS_PER_OMS:
            return {
                ...state,
                notificationsPerOmsCount: action.payload,
                error: false,
                loading: false
            }
        case REDUX.reducers.GET_ALL_NOTICATIONS_PER_DAMAGE:
            return {
                ...state,
                notificationsPerDamageCount: action.payload,
                error: false,
                loading: false
            }
        case REDUX.reducers.SET_DAMAGE_LEVEL_LIST:
            return {
                ...state,
                damageLevel: action.payload,
                error: false,
                loading: false
            }
        case REDUX.reducers.GET_AUTO_NOTIFICATION:
            return {
                ...state,
                autoNotification: action.payload,
                error: false,
                loading: false
            }
        case REDUX.reducers.GET_ALL_NOTICATIONS_PER_LOCATION:
            return {
                ...state,
                notificationsPerUnityCount: action.payload,
                error: false,
                loading: false
            }
        case REDUX.reducers.GET_ALL_NOTICATIONS_PER_SECTOR:
            return {
                ...state,
                notificationsPerSectorCount: action.payload,
                error: false,
                loading: false
            }
        case REDUX.reducers.GET_ALL_NOTICATIONS_PER_INCIDENT_SECTOR:
            return {
                ...state,
                notificationsPerIncidentSectorCount: action.payload,
                error: false,
                loading: false
            }
        case REDUX.reducers.ERROR_NOTIFICATIONS:
            return {
                ...state,
                notificationsList: [],
                error: true,
                loading: false,
                loadingStats: false,
            } as NotificationReducer
        case REDUX.reducers.GET_ALL_NOTIFICATIONS_TO_DOWNLOAD_CSV_DATA:
            return {
                ...state,
                notificationsCsvReport:action.payload,
                error: false,
                loading: false,
                loadingStats: false,
            } as NotificationReducer
        case REDUX.reducers.CLEAN_CSV_DATA:
            return {
                ...state,
                notificationsCsvReport:'',
                error: false,
                loading: false,
                loadingStats: false,
            } as NotificationReducer
        case REDUX.reducers.GET_ALL_NOTIFICATIONS_COUNT:
            return {
                ...state,
                notificationCount: action.payload,
                error: true, //! IS THIS CORRECT?
                loading: false
            } as NotificationReducer
        case REDUX.reducers.GET_COUNT_ALL_NOTIFICATIONS_BY_STATUS:
            const payload = action.payload as any
            const finalizedBySubStatus = payload?.finalizedBySubStatus
            const { finalizedBySubStatus: _, ...notificationCountByStatus } = payload
            
            return {
                ...state,
                notificationCountByStatus: finalizedBySubStatus ? notificationCountByStatus : action.payload,
                finalizedBySubStatus: finalizedBySubStatus || state.finalizedBySubStatus,
                error: false,
                loading: false
            } as NotificationReducer
        case REDUX.reducers.GET_NOTIFICATION_COUNT_BY_SUB_DAMAGE_LEVEL:
            return {
                ...state,
                notificationCountBySubDamageLevel: action.payload ?? [],
                error: false,
                loading: false
            } as NotificationReducer
        case REDUX.reducers.GET_MULTIPLIER_STATS:
            return {
                ...state,
                multiplierStats: action.payload ?? {
                    totalNotifications: 0,
                    totalMultiplier: 0
                },
                error: false,
                loading: false
            } as NotificationReducer
        case REDUX.reducers.ALL_USER_NOTIFICATION_STATISTICS:
            return {
                ...state,
                sumOfTimeEventToNotification: action.payload,
                error: false,
                loading: false,
                loadingStats: false,
            } as NotificationReducer
        case REDUX.reducers.GET_ALL_NOTIFICATIONS_BY_STATUS:
            return {
                ...state,
                notificationsList: action.payload.map(
                    (status: string) => status['u_state' as keyof typeof status]
                ),
                error: true,//! IS THIS CORRECT?
                loading: false
            } as NotificationReducer
        case REDUX.reducers.CURRENT_ISHIKAWA_DIAGRAM:
            return {
                ...state,
                ishikawaDiagram: action.payload,
                error: false,
                loading: false
            } as NotificationReducer
        case REDUX.reducers.CURRENT_LONDON_PROTOCOL:
            return {
                ...state,
                londonProtocol: action.payload,
                error: false,
                loading: false
            } as NotificationReducer
        case REDUX.reducers.CURRENT_ACCOUNTABILITY_MATRIX:
            return {
                ...state,
                accountabilityMatrix: action.payload,
                error: false,
                loading: false
            } as NotificationReducer
        case REDUX.reducers.CURRENT_TYPE_OF_DIAGNOSIS:
            return {
                ...state,
                typesOfDiagnosis: [action.payload],
                error: false,
                loading: true //! IS THIS CORRECT?
            } as NotificationReducer
        case REDUX.reducers.CURRENT_SENTINEL_EVENT:
            return {
                ...state,
                sentinelEvent: action.payload,
                error: false,
                loading: false
            } as NotificationReducer
        case REDUX.reducers.NEVER_EVENTS:
            return {
                ...state,
                neverEvents: action.payload,
                error: false,
                loading: false
            } as NotificationReducer
        case REDUX.reducers.GET_NOTIFICATION_FACTORS:
            return {
                ...state,
                factors: action.payload,
                error: false,
                loading: false
            } as NotificationReducer
        case REDUX.reducers.GET_NOTIFICATION_PROTOCOL_VARIBLES:
            return {
                ...state,
                londonVaribles: action.payload,
                error: false,
                loading: false
            } as NotificationReducer
 
        case REDUX.reducers.SET_CURRENT_NAV_ITEM:
            return {
                ...state,
                currentNavItem: action.payload,
                error: false,
                loading: false
            } as NotificationReducer
        case REDUX.reducers.SET_PROGRESS_BAR_NAV_CLICKED:
            return {
                ...state,
                progressBarNavClicked: action.payload,
                error: false,
                loading: false
            } as NotificationReducer
        case REDUX.reducers.GET_COUNT_LAST_RECLASSIFIED_INCIDENT_TYPE:
            return {
                ...state,
                notificationCountLastReclassifiedIncidentType: action.payload,
                error: false,
                loading: false
            } as NotificationReducer
        case REDUX.reducers.NOTIFICATION_PROCESS_REQUIRED_STEPS_RULES:
            return {
                ...state,
                notificationProcessRequiredStepsRules: action.payload,
                error: false,
                loading: false
            } as NotificationReducer
        default:
            break
    }

    return state
}

export default NotificationsReducer
